"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HippyDataReporterAdapter = void 0;
var js_base64_1 = require("js-base64");
var HippyDataReporterAdapter = (function () {
    function HippyDataReporterAdapter(params) {
        this.registeredPlugins = [];
        try {
            this.configs = params;
            var appid = params.appid;
            this.userActionRaw = {
                appid: appid,
            };
        }
        catch (error) {
            console.log('init error', error);
        }
    }
    Object.defineProperty(HippyDataReporterAdapter.prototype, "appId", {
        get: function () {
            return this.userActionRaw.appid;
        },
        set: function (_appId) {
            this.userActionRaw.appid = _appId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HippyDataReporterAdapter.prototype, "raw", {
        get: function () {
            return this.userActionRaw;
        },
        set: function (_raw) {
            this.userActionRaw = _raw;
        },
        enumerable: false,
        configurable: true
    });
    HippyDataReporterAdapter.prototype.genUserActionReportData = function (data) {
        var _a;
        try {
            if (!data || !data.user_action) {
                return '';
            }
            data = Object.assign({}, this.userActionRaw, data, {
                timestamp: Date.now(),
            });
            var ret = js_base64_1.Base64.encode(encodeURIComponent(JSON.stringify(data)));
            if (!((_a = this.configs) === null || _a === void 0 ? void 0 : _a.silent)) {
                console.log('ret', ret);
            }
            return ret;
        }
        catch (error) {
            console.log(error);
            return '';
        }
    };
    HippyDataReporterAdapter.prototype.reportUserAction = function (raw) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_b) {
                data = this.genUserActionReportData(raw);
                if (!data)
                    throw Error("invalid report data: " + data);
                try {
                    if (fetch) {
                        return [2, Promise.race([
                                fetch("https://ugpage.html5.qq.com/proxy/stat/reportData?data=" + encodeURIComponent(data)),
                                new Promise((function (resolve, reject) {
                                    setTimeout(function () { return reject(new Error('网络状况不太好,再刷新一次?')); }, parseInt('500', 10));
                                })),
                            ])
                                .then(function (res) {
                                if (res.status === 200) {
                                    return res.json();
                                }
                                return Promise.reject(new Error("\u7F51\u7EDC\u72B6\u51B5\u9519\u8BEF~,\u7F51\u7EDC\u72B6\u6001\u53F7\u4E3A: " + res.status));
                            })
                                .catch(function (error) { return Promise.reject(new Error(error.message)); })];
                    }
                }
                catch (error) {
                    if ((_a = this.configs) === null || _a === void 0 ? void 0 : _a.silent) {
                        return [2];
                    }
                    throw error;
                }
                return [2];
            });
        });
    };
    return HippyDataReporterAdapter;
}());
exports.HippyDataReporterAdapter = HippyDataReporterAdapter;
//# sourceMappingURL=index.js.map